import ExerciseGenerator from "./ExerciseGenerator";
import {getRandomIntegerWithRange} from "../Random";
import Exercise from "../Exercise";
import {binaryToDecimal, decimalToBinary} from "../logic/Conversion";
import Modes from "../mode/Modes";
//import Constants from "../../components/constants";
import ResultItem from "../ResultItem";
import NumberSystems from "../NumberSystems";

const BIAS = 127;
export default class IEEE754ExerciseGenerator extends ExerciseGenerator{

    generate = (task) => {
        let result;
        let decimalTask;
        if(!task){
            let integers = getRandomIntegerWithRange(1, 256);
            //Copied from android app, prevents too long tasks (long means space in the UI)
            const presetValues = [0.5, 0.25, 0.125, 0.0625, 0.03125, 0.015625];
            //Result will always be divisible by 5 which prevents too long tasks
            let decimals = 0.0;
            let changedValue = false;
            for (let i = 0; String(decimals).length < 6 && i < presetValues.length; i++) {
                const rnd = Math.random() >= 0.5;
                if (rnd) {
                    decimals += presetValues[i];
                    changedValue = true;
                }
            }
            // if still zero, select one of the values randomly
            // (no float comparisons to 0.0)
            if (! changedValue) {
                // 4 for the same reason as 6 on the for-loop before
                decimals = presetValues[getRandomIntegerWithRange(0,4)];
            }
            task = Number(integers+decimals);
            if (Math.random() >= 0.5) {
                task *= -1;
            }
            decimalTask = task;
        }


        if(this.mode.equals(Modes.DECIMAL_FLOATING_POINT_TO_IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS)){
            result = this.decimalToIEEE(task);
        }else if(this.mode.equals(Modes.IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS_TO_DECIMAL_FLOATING_POINT)){
            //Convert task (decimal floating point) to ieee
            task = this.decimalToIEEE(task);
            //Task is now an array, the last element is the final result in an object
            task = task[task.length-1].getValue();
            //Calculate the result (Its an array so we need to run the function)
            result = this.ieeeToDecimal(task);
        }else{
            console.error(this.mode);
            throw new Error("Unknown mode");
        }
        return new Exercise([decimalTask], [task], result);
    };

    ieeeToDecimal(task) {
        task = String(task);
        const result = [];
        //If the binary value starts with 1, its negative. Else its positive
        const sign = task.substring(0,1) === "1" ? "-" : "+";
        const biasExponent = task.substring(1, 9);
        const paddedMantissa = task.substring(9, task.length);

        //Remove trailing zeros first
        // This is no problem, if both, the integer and fractional part, are != 0
        let mantissaNoPadding = paddedMantissa.replace(/0*$/, '');

        //Step 1. Extract the mantissa, add the truncated 1 back on
        let step1Value = sign+"1."+mantissaNoPadding;
        if(mantissaNoPadding === ""){ 
            // this should never happen if both, the integer and fractional part, are != 0
            //If paddedMantissa is empty, do not add a decimal point
            step1Value = step1Value.split(".")[0];
        }
        result.push(new ResultItem(step1Value, NumberSystems.BINARY, true, true, true));
        //Step 2. Find the exponent
        const decimalBiasExponent = binaryToDecimal(biasExponent);
        let exponent = decimalBiasExponent - BIAS;
        exponent = Math.round(exponent);

        result.push(new ResultItem(exponent, NumberSystems.DECIMAL, true, true));

        //Step 3
        //shift decimal point in step1Value exponent places to the right
        //Note: this only works if abs(number) >= 1, i.e. not 0.125, for example
        result.push(
            new ResultItem(
                step1Value.substring(0, 2)+
                step1Value.substring(3, 3+exponent)+
                "."+
                step1Value.substring(3+exponent, step1Value.length),
                NumberSystems.BINARY,
                true, true, true
            )
        );
        
        //Step 4. Calculate the mantissa by multiplying values to the power of their index within the mantissa
        let mantissa = 0;
        for(let i = 0; i<paddedMantissa.length; i++){
            //Value at index in padded mantissa
            const value = Number(paddedMantissa.charAt(i));
            //If the value is 0, we don't have to do anything
            if(value === 0){
                continue;
            }
            //Whats the exponent?
            //The Exponent is the index of the element + 1 (Adjusting for zero indexed array) * -1
            //Take the value at the index * 2 ^ ((i+1)*-1)
            const power = (i+1)*-1;
            const calculatedValue = value * Math.pow(2, power);
            mantissa = mantissa+calculatedValue;
        }
        //Step 4a. Merge the mantissa calculation
        const convertedMantissa = (1+mantissa) * Math.pow(2, exponent);
        //Step 4b. Apply the sign
        const convertedSignedMantissa = sign === "-" ? convertedMantissa * -1 : convertedMantissa;
        //Done!
        result.push(new ResultItem(convertedSignedMantissa, NumberSystems.DECIMAL, true, true, true));
        return result;
    }

    decimalToIEEE(task) {
        const result = [];

        //Step 1. Convert the integer and decimal places to binary
        const sign = task < 0 ? "-" : "+";
        const taskString = String(task).split(".");
        let integer = Number(taskString[0]);
        const decimals = Number("0."+taskString[1]);
        if(integer < 0){
            //Turn it positive for now
            integer = integer * -1;
        }

        const binaryInteger = decimalToBinary(integer);
        let binaryDecimals = decimalToBinary(decimals);
        //Since we are going to concat all the numbers as strings, we can now remove the 0. from binaryDecimals
        binaryDecimals = binaryDecimals.substring(1, binaryDecimals.length);
        //Step 1a. Merge them together and store them in the result
        result.push(new ResultItem(sign+binaryInteger+binaryDecimals, NumberSystems.BINARY, true, true, true));

        //Step 2. Shift the decimal place to after the first digit
        result.push(
            new ResultItem(
                sign+binaryInteger.substring(0, 1)+
                "."+
                binaryInteger.substring(1, binaryInteger.length)+
                binaryDecimals.split(".")[1],
                NumberSystems.BINARY,
                true, true, true
            )
        );

        //Step 2a. Note the exponent. Its value is the number of places that we shifted the decimal point
        result.push(new ResultItem(result[0].getValue().indexOf(".")-2, NumberSystems.DECIMAL, true, true)); //-1 for the sign -1 for zero index = -2

        //Step 3. Construct IEEE 754 value
        //Sign
        const ieeeSign = task<0 ? "1" : "0";
        //Index 2 contains our exponent
        const adjustedBias = BIAS+result[2].getValue();
        const adjustedBiasBinary = decimalToBinary(adjustedBias);
        //Mantissa
        //The mantissa is the value after the decimal place in step 2
        const mantissa = result[1].getValue().split(".")[1];

        //Step 3a. compile the value
        let ieeeValue = ieeeSign+adjustedBiasBinary+mantissa;
        //Step 3b. fill up the value until we reach 32 bit
        while(ieeeValue.length < 32){
            ieeeValue+="0";
        }
        result.push(new ResultItem(ieeeValue, NumberSystems.BINARY));
        //Done!
        return result;
    }
}